import { Grid, Typography } from "../../basics";
import { IInnerSectionProps } from "./types";

const InnerSection = (props: IInnerSectionProps) => {

    return (
        <Grid item sx={{mt: props.mt}}>
            <Typography variant='caption'>
                {props.title}
            </Typography>
            {   props.text ?
                <Typography variant="h2" mt={2}>
                    {props.text}
                </Typography> :
                props.children
            }
        </Grid>
    )
}

export {InnerSection}